import script from "./WorkspaceSourcePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkspaceSourcePanel.vue?vue&type=script&setup=true&lang=ts"

import "./WorkspaceSourcePanel.vue?vue&type=style&index=0&id=4d98a70a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d98a70a"]])

export default __exports__